<template lang="html">
  <div id="app">
    <div :class="['wrapper', 'js-wrapper', { 'is-map': isMap() }]">
      <div class="block js-block">
        <Header></Header>
        <div :class="['sortArea', { 'is-map': isMap() }]">
          <Category></Category>
          <Tag></Tag>
        </div>
        <Lead :path-to-child-prop="path()"></Lead>
      </div>
      <div class="js-transition_item">
        <router-view class="rt"></router-view>
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./components/Common/Header/_index.vue";
import Category from "./components/Common/Category/_index.vue";
import Tag from "./components/Common/Tag/_index.vue";
import Lead from "./components/Common/Lead/_index.vue";
import Footer from "./components/Common/Footer/_index.vue";
// import { union } from "underscore";
// import firebase from "firebase/app";
// import "firebase/database";
import axios from "axios";

export default {
  name: "App",
  components: {
    Header,
    Category,
    Tag,
    Lead,
    Footer
  },
  computed: {
    // category() {
    //   return this.$store.state.category;
    // },
    // selected_category() {
    //   return this.$store.state.selected_category;
    // },
    // selected_tag() {
    //   return this.$store.state.selected_tag;
    // }
  },
  methods: {
    getMembers(cb) {
      axios.get("https://us-central1-teampage.cloudfunctions.net/api/notion/db/teampage")
        .then((res) => {
          const members = res.data.responseBody;
          members.map((member, index) => {
            member.id = index + 1;
            if (member.Name.length == 0) {
              member.id = 0;
            }
            if (member.Alphabet.length == 0) {
              member.Alphabet = null;
            }
            if (member.hobby.length == 0) {
              member.hobby = null;
            }
            if (member.image.length == 0) {
              member.image = "/static/img/member/pic01.png";
            }
            if (member.Name.indexOf("フジア") !== -1 || member.Name.indexOf("Fujiko") !== -1) {
              member.id = 0;
            }
            if (typeof member.Alphabet !== "object") {
              if (!member.Alphabet.match(/^[\x20-\x7e]*$/)) {
                member.id = 0;
              }
            }
          });

          const newMembers = members.filter(n => n.id != 0);

          this.$store.commit("setCity", newMembers);

          cb(newMembers);
        });
    },
    path() {
      if (this.$route.path == "/") {
        return "/map";
      } else if (this.$route.path == "/map") {
        return "/";
      }
    },
    isMap() {
      return this.$route.path == "/map";
    },
    layout() {
      const wrapper = document.querySelector(".wrapper");
      wrapper.style.height = `${window.innerHeight}px`;
    }
  },
  mounted() {
    if (this.isMap()) this.layout();
  },

  created() {
    this.getMembers(members => {
      this.$store.commit("setMembers", members);
    });
  }
};
</script>

<style lang="scss" scoped>
#app {
  // min-height: 100vh;
}

.wrapper {
  background-color: #fff;
  padding: 50px 80px 30px;
  position: relative;
  height: 100%;

  @include max(768) {
    padding: 30px;
  }

  &.is-map {
    height: 100vh;
    background-color: #000;
  }
}

.sortArea {
  &.is-map {
    opacity: 0;
    pointer-events: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue